import React from 'react';
import { Row, Col } from 'antd';
import { PersonaSearchField } from './PersonaSearchField';
import { Persona } from '../../../hooks/usePersonas';

interface PersonasOpcionalesProps {
  personas: Persona[];
  selectedDespachante: Persona | null;
  selectedCorredor: Persona | null;
  selectedEntregador: Persona | null;
  onDespachanteSelect: (persona: Persona | null) => void;
  onCorredorSelect: (persona: Persona | null) => void;
  onEntregadorSelect: (persona: Persona | null) => void;
}

export const PersonasOpcionales: React.FC<PersonasOpcionalesProps> = ({
  personas,
  selectedDespachante,
  selectedCorredor,
  selectedEntregador,
  onDespachanteSelect,
  onCorredorSelect,
  onEntregadorSelect
}) => {
  return (
    <Row gutter={[16, 16]}>
      <Col span={8}>
        <PersonaSearchField
          label="Despachante"
          personas={personas}
          selectedPersona={selectedDespachante}
          onSelect={onDespachanteSelect}
        />
      </Col>
      <Col span={8}>
        <PersonaSearchField
          label="Corredor"
          personas={personas}
          selectedPersona={selectedCorredor}
          onSelect={onCorredorSelect}
        />
      </Col>
      <Col span={8}>
        <PersonaSearchField
          label="Entregador"
          personas={personas}
          selectedPersona={selectedEntregador}
          onSelect={onEntregadorSelect}
        />
      </Col>
    </Row>
  );
};

